module.exports = __webpack_public_path__ + "static/media/CongratulationStep.6a97a62d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/OnBoarding/Steps/assets/CongratulationStep.svg
// module id = 932
// module chunks = 0